import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./components/login/login.component";
import { ValAssetsComponent } from "./components/val-assets/val-assets.component";
import { SearchLibComponent } from "./modules/assetModule/components/search-lib/search-lib.component";
import { HomeComponent } from "./modules/homeModule/components/home/home.component";
import { ProfileComponent } from "./modules/userModule/components/profile/profile.component";
import { PersonalBrowserComponent } from "./modules/assetModule/components/personal-browser/personal-browser.component";
import { SettingsComponent } from "src/app/modules/userModule/components/settings/settings.component";
import { UploadAssetComponent } from "src/app/modules/assetModule/components/upload-asset/upload-asset.component";
import { CanDeactivateGuardService } from "./modules/assetModule/shared/services/can-deactivate-guard.service";
import { UploadNewAssetComponent } from "./modules/assetModule/components/upload-new-asset/upload-new-asset.component";
import { AdminComponent } from "./modules/userModule/components/profile/admin/admin.component";
import { UserProfileComponent } from "./modules/userModule/components/profile/user-profile/user-profile.component";
import { L1Component } from "./modules/userModule/components/profile/l1/l1.component"
import { AuditComponent } from "./modules/userModule/components/profile/audit/audit.component";
import { AdministrationComponent } from "./modules/userModule/components/profile/administration-page/administration-page.component";
import { UserActivityComponent } from "./modules/userModule/components/profile/user-activity/user-activity.component";
import { ManageuserComponent } from "./modules/userModule/components/profile/manageuser/manageuser.component";
import {ApiDocumentationComponent} from './modules/userModule/components/api-documentation/api-documentation.component';
import { FaqComponent } from "./modules/userModule/faq/faq.component";
import { ManagegroupComponent } from './modules/userModule/components/profile/managegroup/managegroup.component';
import { DashboardComponent } from "./modules/userModule/components/dashboard/components/dashboard.component";

const routes: Routes = [
  { path: "", redirectTo: "/login", pathMatch: "full" },
  { path: "login", component: LoginComponent },
  {
    path: "val-assets",
    component: ValAssetsComponent, data: {
      breadcrumb: 'Search'
  },
    children: [
      { path: "", redirectTo: "/val-assets/search", pathMatch: "full" },
      { path: "documentation",component:ApiDocumentationComponent},
      { path: "search", component: SearchLibComponent},
      { path: "faq", component: FaqComponent},
      { path: "search/assets/:folder/:assetId", component: SearchLibComponent },
      { path: "search/assets/:assetId", component: SearchLibComponent },
      { path: "search/folders/:folder", component: SearchLibComponent },
      { path: "home", component: HomeComponent },
      { path: "personal-browser", component: SearchLibComponent },
      { path: "profile/:userId", component: ProfileComponent },
      { path: "settings/:userId", component: SettingsComponent },
      { path: "admin/:userId",component:AdminComponent},
      { path: "userProfile/:userEmailId",component:UserProfileComponent},
      { path: "userGroup/L1",component : L1Component},
      { path: "userGroup/L1/manageuser",component:ManageuserComponent },
      { path: "userGroup/L1/managegroup",component:ManagegroupComponent },
      { path: "user/admin/dashboard", component: DashboardComponent},
  
      { path:"administration",component:AdministrationComponent, children: [
       
        { path:"audit",component:AuditComponent},
        { path:"user-activity",component:UserActivityComponent}
      ]},
      {
        path: "upload-assets/:folder",
        component: UploadAssetComponent,
        canDeactivate: [CanDeactivateGuardService]
      },
      {
        path: "upload-new-asset/:folder",
        component: UploadNewAssetComponent,
        canDeactivate: [CanDeactivateGuardService]
      }
    ]
  }

  // { path: "**", redirectTo: "/val-assets", pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
